<div class="swapa-news-header pt-4">
    <div class="row justify-content-end align-items-center">
        <div class="col-12 col-md-auto">
            <label class="input-group d-flex align-items-center">
                <span class="input-group-prepend text-primary pr-2">
                    Filter by
                </span> 
                <select required class="form-control d-inline-block" [(ngModel)]="selectedFilter"
                    (ngModelChange)="onFilterChange($event)">
                    <option *ngFor="let value of filterbyValues" [ngValue]="value">{{value}}</option>
                </select>
            </label>
        </div>
        <div class="col-12 col-md-auto">
            <label class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <div class="swapa-search"></div>
                    </span>
                </div>
                <input [(ngModel)]="searchText" type="text"
                       class="form-control"
                       name="txtSearch"
                       #txtSearch
                       placeholder="Search Podcast" />
            </label>
        </div>
    </div>
</div>

<div class="swapa-body">
    <h2 [hidden]="!noSearchText">{{noSearchText}}</h2>
    <h2 [hidden]="!loadingText">Loading ...</h2>
    <article class="row" *ngFor="let pod of podcast | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <div class="col-12 col-md-4 mb-2 mb-md-0">
            <img class="cover"
                 src="{{pod.ImagePath}}"
                 alt=""
                 width="100%"
                 height="200" />
        </div>
        <div class="col-12 col-md">
            <a href="{{pod.Url}}">
                <h3 class="text-uppercase">
                    {{pod.PodcastTitle}}
                </h3>
                {{pod.PodcastDate}}
            </a>
            <p>
                {{pod.PodcastSummary }}
            </p>
            <button class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#modal-playaudio"
                     id="openPodcast"
                    #openPodcast
                    (click)="showPodcastPopup(pod)">
                Play Audio
            </button>
        </div>
    </article>
</div>
    <!-- News pagination -->
    <div *ngIf="podcast?.length>0" class="row justify-content-center justify-content-md-between align-items-center">
        <div class="col-12 col-md-auto text-center">
            <span>Showing {{endIndex}} of {{ podcast.length }} results</span>
        </div>
        <div class="col-auto">
            <!--<app-newsarticle-pagination [items]="newsArticles" (changePage)="onChangePage($event)"></app-newsarticle-pagination>-->
            <ngb-pagination [collectionSize]="podcast.length" [(page)]="page" [pageSize]="pageSize" [maxSize]="3" [rotate]="true" [boundaryLinks]="false" (pageChange)="onChangePage($event)" aria-label="Default pagination">
            </ngb-pagination>
        </div>
    </div>